<template>
  <div>
    <div class="mine-box-title">修改手机号</div>
    <div class="mini-form-content">
      <el-form
          :model="formData"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="原手机号" prop="ophone"
                          :rules="[
      { required: true, message: '请输入原手机号', trigger: 'blur' },
    ]"
            >
              <el-input
                  type="text"
                  placeholder="请输入原手机号"
                  v-model="formData.ophone"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="新手机号" prop="phone"
                          :rules="[
      { required: true, message: '请再次输入新手机号', trigger: 'blur'},
    ]"
            >
              <el-input
                  type="text"
                  placeholder="请再次输入新手机号"
                  v-model="formData.phone"

              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item label="短信验证码" prop="code"
                          :rules="[
      { required: true, message: '请输入短信验证码', trigger: 'blur'},
    ]"
            >
              <el-input
                  type="text"
                  placeholder="请输入短信验证码"
                  v-model="formData.code"
              ></el-input>
              <el-button type="primary" @click.prevent="getCode">{{
                  clockSecond > 0 ? clockSecond + 's获取验证码' : '获取验证码'
                }}
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col class="footer-button">
            <el-button type="primary" @click="submitForm('ruleForm')" :loading="saveLoading">确定
            </el-button>
            <!--            <el-button @click="resetForm('ruleForm')" plain>重置</el-button>-->
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>
<style scoped>
.btn {
  padding: 0 0.3rem;
  margin-top: 0.3rem;
}

</style>

<script>
import {Toast} from 'vant';

export default {
  name: 'SetPhone',
  comments: {
    Toast
  },
  data: function () {
    return {
      formData: {
        ophone: '',
        phone: '',
        code: '',
      },
      clockSecond: 0,
      formValidate: false,
      saveLoading: false,
    }
  },
  filter: {},
  mounted() {
    document.title = '修改手机'
  },
  destroyed() {
  },
  methods: {
    getCode() {
      let that = this;
      if (that.clockSecond > 0) {
        return;
      }
      this.$api.get('/api/user/phonecode', {}, (res) => {
        Toast(res.msg)
        that.clockSecond = 60;
        var t = setInterval(function () {
          if (that.clockSecond > 0) {
            that.clockSecond = that.clockSecond - 1
          } else {
            clearInterval(t);
          }
        }, 1000)
      })
    },

    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.saveLoading = true;
          that.$api.get('/api/user/editPhone', that.formData, (res) => {
            that.$message.success("修改成功")
            that.$router.go(-1)
            that.saveLoading = false;
          }, (res) => {
            if (res.code == 401 || res.code == 402) {
              that.loginShow = true
            } else {
              Toast(res.msg)
            }
            that.saveLoading = false;
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  }
}
</script>



// WEBPACK FOOTER //
// SetPhone.vue?4bb397ef